import React from 'react';
import { Box } from '@mui/material';

// Soft pastel palette for task / project / QC statuses.
// Matches the Notion/Asana vibe used elsewhere in the app.
const STATUS_PALETTE = {
  // Task / QC statuses
  todo:                 { bg: '#f3f4f6', fg: '#374151' },
  in_progress:          { bg: '#dbeafe', fg: '#1d4ed8' },
  review:               { bg: '#fef3c7', fg: '#b45309' },
  submitted_for_review: { bg: '#cffafe', fg: '#0e7490' },
  completed:            { bg: '#dcfce7', fg: '#15803d' },
  rejected:             { bg: '#fee2e2', fg: '#b91c1c' },
  // Project statuses
  active:               { bg: '#dcfce7', fg: '#15803d' },
  planning:             { bg: '#fef3c7', fg: '#b45309' },
  on_hold:              { bg: '#cffafe', fg: '#0e7490' },
  cancelled:            { bg: '#fee2e2', fg: '#b91c1c' },
};
const DEFAULT = { bg: '#f3f4f6', fg: '#374151' };

export const getStatusPalette = (status) =>
  STATUS_PALETTE[status] || DEFAULT;

export const formatStatusLabel = (status) => {
  if (!status) return 'N/A';
  return String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const StatusPill = ({ status, label }) => {
  const pal = getStatusPalette(status);
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: 0.25,
        bgcolor: pal.bg,
        color: pal.fg,
        fontSize: '0.75rem',
        fontWeight: 600,
        borderRadius: 1,
        whiteSpace: 'nowrap',
        letterSpacing: 0,
      }}
    >
      {label != null ? label : formatStatusLabel(status)}
    </Box>
  );
};

export default StatusPill;
